import { cakeCmsClient } from '../../common/axios/cakeCmsClient';
import { NikeCakeCms } from '../../types/generated/cake-cms';

export function getFbsCurrentInterval() {
    return cakeCmsClient.get<any, NikeCakeCms.FbsCurrentState>('/generic/fbs-current-interval');
}
